const mutationTypes = {
  SET_AUTH: 'setAuth',
  SET_IS_AUTHENTICATED: 'setIsAuthenticated',
  SET_IS_ADMIN: 'setIsAdmin'
};

const state = {
  auth: null,
  isAuthenticated: false,
  isAdmin: false
};

const mutations = {
  [mutationTypes.SET_AUTH]: (state, auth) => state.auth = auth,
  [mutationTypes.SET_IS_AUTHENTICATED]: (state, isAuthenticated) => state.isAuthenticated = isAuthenticated,
  [mutationTypes.SET_IS_ADMIN]: (state, isAdmin) => state.isAdmin = isAdmin
};

const actions = {
  setAuth: ({commit}, auth) => {
    commit(mutationTypes.SET_AUTH, auth);
    commit(mutationTypes.SET_IS_AUTHENTICATED, !!auth);
  },
  setIsAdmin: ({commit}, val) => {
    commit(mutationTypes.SET_IS_ADMIN, val);
  },
  removeAuth: ({commit}) => {
    commit(mutationTypes.SET_AUTH, null);
    commit(mutationTypes.SET_IS_AUTHENTICATED, false);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};